module.exports = {
      id: "green-tick-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "svg-sprite-6b422ea7dc08f55780ae3689062e9e73.svg#green-tick",
      toString: function () {
        return this.url;
      }
    }